<template>
  <div class="container">
    <second-level>
      <div class="title">
        <h3 class="chinese">服务流程及优势</h3>
        <div class="inner">
          <h3 class="english">Service Process and Advantages</h3>
          <p class="line"></p>
        </div>
      </div>
    </second-level>
    <servive-process></servive-process>
  </div>
</template>

<script>
import SecondLevel from "../../SecondLevel";
import ServiveProcess from "./ServiceProcess";
export default {
  name: "Index",
  components: {
    SecondLevel,
    ServiveProcess
  }
  // https://img.zcool.cn/community/018377585896faa8012060c8447719.png@2o.png
};
</script>

<style lang="scss" scoped>
.container {
  width: 75%;
  margin: 0 auto;
}
</style>
